__turbopack_context__.v({
  "chatimageblock": "ChatImageBlock-module-sass-module__83rM6W__chatimageblock",
  "chatimageblock--animated": "ChatImageBlock-module-sass-module__83rM6W__chatimageblock--animated",
  "chatimageblock--editable": "ChatImageBlock-module-sass-module__83rM6W__chatimageblock--editable",
  "chatimageblock__animation--in": "ChatImageBlock-module-sass-module__83rM6W__chatimageblock__animation--in",
  "chatimageblock__bubble": "ChatImageBlock-module-sass-module__83rM6W__chatimageblock__bubble",
  "chatimageblock__bubble__animation--in": "ChatImageBlock-module-sass-module__83rM6W__chatimageblock__bubble__animation--in",
  "chatimageblock__bubble__image": "ChatImageBlock-module-sass-module__83rM6W__chatimageblock__bubble__image",
});
